// extracted by mini-css-extract-plugin
export var container = "_5g-0";
export var disabled = "_5g-4";
export var fullWidth = "_5g-3";
export var lined = "_5g-1";
export var selected = "_5g-5";
export var tab = "_5g-2";